export default __webpack_public_path__ + "img/1.asset.61ccc97d.jpeg";